/**
 * Client (WebAPI) transformer for user profile
 *
 * Maps the 4-field WebAPI UserProfileResponse to the same
 * UserProfileDetail shape so pages and components need zero changes.
 */

import type { ClientUserProfileResponse } from '@/store/api/endpoints/client/userProfileApi';
import type { UserProfileDetail } from './transformers';

export function clientProfileToUserProfileDetail(
  data: ClientUserProfileResponse,
): UserProfileDetail {
  const parts = (data.name ?? '').trim().split(/\s+/);
  const firstName = parts[0] ?? '';
  const lastName = parts.length > 1 ? parts.slice(1).join(' ') : '';
  // Normalize to lowercase for consistent display across the app.
  const email = (data.email ?? '').toLowerCase();
  const fullName = data.name || email;

  return {
    id: data.id,
    userSub: data.id,
    firstName,
    lastName,
    fullName,
    salutation: null,
    jobTitle: null,
    email,
    mobilePhone: null,
    mobilePhoneCountryCode: null,
    officePhone: null,
    officePhoneCountryCode: null,
    primaryWorkLocation: null,
    linkedIn: null,
    timeZone: null,
    profilePictureId: null,
    pictureUrl: data.pictureUrl,
    role: data.role ?? null,
    createdAt: '',
    createdAtFormatted: '-',
  };
}
